import { actions } from 'react/api/actions/i18n';
import { fromJS } from 'immutable';

const initialState = fromJS({
  locale: {
    language: 'en'
  },
  resources: {}
});

export default (state = initialState, action) => {

  if (actions.setLocale === action.type) {
    return state.set('locale', fromJS(action.payload));
  }

  if (actions.fetchResourcesByKeySuccess === action.type) {
    const resources = action.payload;
    resources.forEach(resource => {
      state = state.setIn(['resources', resource.key], resource.value);
    });
    return state;
  }

  return state;
};
